var _style, _script, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 264",
    style: {
      enableBackground: "new 0 0 192 264"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000181075157615633916300000011101275253533610120_);}\r\n\t.st2{fill:url(#SVGID_00000142895758126606204450000006257648308756121259_);}\r\n\t.st3{fill:url(#SVGID_00000112594468184231204570000001703356968692950914_);}\r\n\t.st4{fill:url(#SVGID_00000161628385610935073970000001638475965778886019_);}\r\n\t.st5{fill:url(#SVGID_00000146474799609767317650000008796246436533600423_);}\r\n\t.st6{fill:url(#SVGID_00000142893519866851675580000013890430202431395503_);}\r\n\t.st7{fill:url(#SVGID_00000152979656779361144860000002269522161943147434_);}\r\n\t.st8{fill:url(#SVGID_00000114781599775195515570000010866593628599473074_);}\r\n\t.st9{fill:url(#SVGID_00000029768357283384777480000003865461338221871800_);}\r\n\t.st10{fill:url(#SVGID_00000083800323413135603400000001957543172894692748_);}\r\n\t.st11{fill:url(#SVGID_00000018948352178145420170000011417035109379791747_);}\r\n")), _script || (_script = /*#__PURE__*/React.createElement("script", {
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb",
    id: "argent-x-extension",
    xmlns: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.963,
    y1: 191.2074,
    x2: 108.963,
    y2: 61.2074,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA72A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C1915"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,79l71-10l-0.2,111.9L58,191V79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008144294108545833940000015807083723491962521_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.8061,
    y1: 126.121,
    x2: 99.3178,
    y2: 106.679,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6991C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000008144294108545833940000015807083723491962521_)"
    },
    d: " M118.5,135.2l0,4.1l-49.5,7l0-4.1L118.5,135.2z M118.5,146.6l0,4.1l-49.5,7l0-4.1L118.5,146.6z M118.4,162.2l0-4.1l-49.5,7l0,4.1 L118.4,162.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109008543986556614950000006784325222906206132_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.524,
    y1: 190,
    x2: 55.524,
    y2: 69.5,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA72A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C1915"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109008543986556614950000006784325222906206132_)"
    },
    d: "M58,191l-5-3V76l5,3L58,191z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009565557552638198810000001579804078658375319_",
    gradientUnits: "userSpaceOnUse",
    x1: 53,
    y1: 72.5,
    x2: 129,
    y2: 72.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6991C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009565557552638198810000001579804078658375319_)"
    },
    d: "M58,79l-5-3l70-10l6,3L58,79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021836310898330558830000011667813275072462754_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.5903,
    y1: 160.6228,
    x2: 108.7335,
    y2: 147.9288,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6991C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021836310898330558830000011667813275072462754_)"
    },
    d: "M93.8,88.2c10.4-1.5,18.8,6.5,18.8,17.7 c0,11.2-8.5,21.6-18.9,23.1c-10.4,1.5-18.8-6.5-18.8-17.7C75,100,83.5,89.6,93.8,88.2z M93.8,125.4c8.5-1.2,15.5-9.7,15.5-19 c0-9.3-6.9-15.8-15.5-14.6c-8.5,1.2-15.5,9.7-15.5,19C78.3,120,85.2,126.6,93.8,125.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070090894003266860870000016405797497094272665_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.2042,
    y1: 155.1753,
    x2: 105.7038,
    y2: 153.6753,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6991C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070090894003266860870000016405797497094272665_)"
    },
    d: "M100.6,100.5l2.3,2.2l-11.5,14.1l-6.9-6.5 l2.4-2.9l4.6,4.3L100.6,100.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161630074564961895300000015235833028419829381_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.658,
    y1: 64.2916,
    x2: 126.158,
    y2: 61.2916,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D110F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161630074564961895300000015235833028419829381_)"
    },
    d: "M110.2,207.4l-2.3-16.5l16.3,7.5 L110.2,207.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017477506014103146270000016179636753250556061_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.7885,
    y1: -88.0614,
    x2: 271.7885,
    y2: -174.0614,
    gradientTransform: "matrix(-0.9081 -0.4187 -0.4187 0.9081 325.9796 388.4971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59D1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5931C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000017477506014103146270000016179636753250556061_)"
    },
    points: "118.8,196 113.3,193.5  149.3,115.4 154.8,117.9 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182512196734666714930000001060126209281186466_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.2375,
    y1: -90.5734,
    x2: 277.2375,
    y2: -176.5734,
    gradientTransform: "matrix(-0.9081 -0.4187 -0.4187 0.9081 335.3252 395.5719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E28F1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D110F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000182512196734666714930000001060126209281186466_)"
    },
    points: "124.2,198.5 118.8,196  154.8,117.9 160.2,120.4 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082352537660437047790000017615793977976936854_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.3405,
    y1: -85.5494,
    x2: 266.3405,
    y2: -171.5494,
    gradientTransform: "matrix(-0.9081 -0.4187 -0.4187 0.9081 316.636 381.4228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE8F1C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000082352537660437047790000017615793977976936854_)"
    },
    points: "113.3,193.5 107.9,191  143.9,112.9 149.3,115.4 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033365843604931990490000001713620336724162747_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.1725,
    y1: -14.1243,
    x2: 328.7505,
    y2: -13.8173,
    gradientTransform: "matrix(-0.9081 -0.4187 -0.4187 0.9081 436.7335 261.6263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D110F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#81521C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000033365843604931990490000001713620336724162747_)"
    },
    points: "160.2,120.4 143.9,112.9  145.1,110.1 161.5,117.7 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126283117704909828610000011580203707485412504_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.2706,
    y1: 149.7396,
    x2: 148.2196,
    y2: 157.1436,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D110F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5931C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126283117704909828610000011580203707485412504_)"
    },
    d: "M161.5,117.7l-16.3-7.5l2.5-5.5 c0.9-2,3.3-2.9,5.3-2l9.1,4.2c2,0.9,2.9,3.3,2,5.3L161.5,117.7z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteIcon);
export default __webpack_public_path__ + "static/media/vote-icon.6f3a2129001754dd5bfee5e2ce6c1e18.svg";
export { ForwardRef as ReactComponent };